import React from 'react';
import Navbar from '../components/LandingPageNew/Navbar';
import Hero from '../components/About/Hero';
import Footer from '../components/LandingPageNew/Footer';
import TeamShowcase from '../components/About/TeamShowcase';
const AboutUs = () => {
    return (
        <div className="relative min-h-screen">
            {/* Navbar on top of hero */}
            <Navbar />

            <Hero/>
            <TeamShowcase/>
            <Footer/>
        </div>
    );
};

export default AboutUs;
